import { FileRecord } from "./file-record";

export enum StaticContentTypeEnum {
  NEWS = 'NEWS',
  INFORMATIONAL_CONTENT = 'INFORMATIONAL_CONTENT',
  OTHER = 'OTHER',
}

export enum StaticContentSectionEnum {
  HEALTHCARE_SPECIALISTS = 'HEALTHCARE_SPECIALISTS',
  HEALTHCARE_INSTITUTIONS = 'HEALTHCARE_INSTITUTIONS',
  EDUCATION_PROVIDERS = 'EDUCATION_PROVIDERS',
}

export enum StaticContentPageEnum {
  SPECIALIST_ATTRACTION_PROJECT = 'SPECIALIST_ATTRACTION_PROJECT',
}

export enum StaticContentStatusEnum {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  CANCELED = 'CANCELED',
  PENDING_PUBLISH = 'PENDING_PUBLISH',
}

export type StaticContent = {
  id: number;
  title: string | null;
  content: string;
  files: FileRecord[];
  type: StaticContentTypeEnum;
  section: StaticContentSectionEnum | null;
  priority: number | null;
  page: StaticContentPageEnum | null;
  status: StaticContentStatusEnum;
  publishAt: string;
  shortSummary: string | null;
};

export type StaticContentFilters = {
  title?: string;
  status?: StaticContentStatusEnum;
  publishDate?: string;
  type?: StaticContentTypeEnum;
};

export type SendStaticContentForm = {
  title?: string | null;
  content: string;
  files: number[];
  publishAt: string | null;
  shortSummary?: string | null;
  type: StaticContentTypeEnum;
  section?: StaticContentSectionEnum;
  priority?: number | null;
  page?: StaticContentPageEnum;
}

export type SendChangeStaticContentStatusForm = {
  status: StaticContentStatusEnum;
}
